import { render, staticRenderFns } from "./TablePaginated.vue?vue&type=template&id=1db53f7b&scoped=true&"
import script from "./TablePaginated.vue?vue&type=script&lang=js&"
export * from "./TablePaginated.vue?vue&type=script&lang=js&"
import style0 from "./TablePaginated.vue?vue&type=style&index=0&id=1db53f7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db53f7b",
  null
  
)

export default component.exports